// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import store from "./vuex";
import App from "./App";
import router from "./router";
// import "@/assets/common/rem.js";
import Antd from "ant-design-vue";
import ELEMENT from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css'
import "ant-design-vue/dist/antd.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "../node_modules/swiper/dist/css/swiper.css";
import axios from "./utils/axios";
// import VueCropper from 'vue-cropper'

import md5 from "js-md5";

import VueI18n from "vue-i18n";

// import * as echarts from 'echarts';
// Vue.prototype.$echarts = echarts

// import throttle from 'v-throttle'
// Vue.use(throttle)
// 引入语言包
// import LangEN from "@/assets/common/lang/en.js";
// import LangCN from "@/assets/common/lang/cn.js";

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "en",
  messages: {
    en: require("./assets/common/lang/en.js"),
    zh: require("./assets/common/lang/cn.js")
  },
  silentTranslationWarn: true
});
Vue.prototype.$md5 = md5;
// Vue.use(VueCropper)
Vue.prototype.$axios = axios;

Vue.use(ELEMENT);

Vue.use(VueAwesomeSwiper);
Vue.use(Antd);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  console.log("i18n.t('router.' + [to.meta.title])", to);
  document.title = i18n.t("router." + [to.meta.title]);
  next();
});
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: {
    App
  },
  template: "<App/>",
  created() {}
});



// WEBPACK FOOTER //
// ./src/main.js